(function () {

  angular
    .module("alk.marketing")
    .directive("marketingFooter", marketingFooter);

  //marketingFooter.$inject = [];
  function marketingFooter() {
    var directive = {
      template: require("./footer.html"),
      link: link,
      restrict: "E",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {}
  }

})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-marketing/footer.directive.js